/**
 * Strip `.duplicate.N.removed` suffix added by SQL migration
 * `20260605000001_add_unique_constraints.sql` during deduplication.
 */
export function cleanEmail(email: string | null | undefined): string {
  if (!email) return "";
  return email.replace(/\.duplicate\.\d+\.removed/g, "");
}
